// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/mountain-wave.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/mountain-wave/mountain-wave-cloud-signs.js';
import g1 from '../lessons/meteorology/mountain-wave/mountain-wave.js';

mount([g0, g1]);
